export default __webpack_public_path__ + "static/media/severe-graph.ab05ffcf.svg";